import React from "react";
import { Row, Col, Typography, Button, Space, Grid } from "antd";
import {
  CheckCircleFilled,
  ArrowRightOutlined,
} from "@ant-design/icons";

const { Title, Paragraph } = Typography;
const { useBreakpoint } = Grid;

function ProofResultsSection() {
  const screens = useBreakpoint();
  const isDesktop = screens.lg;

  const highlights = [
    "Brilho sofisticado e uniforme",
    "Acabamento visual premium",
    "Mais confiança no resultado final",
  ];

  return (
    <section
      style={{
        background: "#111111",
        padding: isDesktop ? "32px 24px" : "72px 16px",
        minHeight: isDesktop ? "100vh" : "auto",
        display: "flex",
        alignItems: "center",
      }}
    >
      <div
        style={{
          maxWidth: 1280,
          width: "100%",
          margin: "0 auto",
          height: isDesktop ? "calc(100vh - 64px)" : "auto",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Row
          gutter={isDesktop ? [28, 28] : [0, 24]}
          align="stretch"
          style={{
            width: "100%",
            height: isDesktop ? "100%" : "auto",
          }}
        >
          <Col
            xs={24}
            lg={10}
            style={{
              display: "flex",
              height: isDesktop ? "100%" : "auto",
            }}
          >
            <div
              style={{
                width: "100%",
                maxWidth: isDesktop ? 520 : "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                height: "100%",
              }}
            >
              <span
                style={{
                  display: "inline-block",
                  width: "fit-content",
                  padding: isDesktop ? "8px 14px" : "7px 12px",
                  borderRadius: 999,
                  background: "rgba(199,163,106,0.12)",
                  border: "1px solid rgba(199,163,106,0.28)",
                  color: "#d2ab71",
                  fontSize: isDesktop ? 13 : 12,
                  fontWeight: 600,
                  letterSpacing: 0.4,
                  marginBottom: 18,
                }}
              >
                RESULTADO REAL DAS PEÇAS
              </span>

              <Title
                level={2}
                style={{
                  color: "#ffffff",
                  marginBottom: 18,
                  fontSize: isDesktop ? "clamp(34px, 4vw, 54px)" : "32px",
                  lineHeight: isDesktop ? 1.05 : 1.15,
                }}
              >
                Qualidade e acabamento que valorizam suas peças
              </Title>

              <Paragraph
                style={{
                  color: "rgba(255,255,255,0.72)",
                  fontSize: isDesktop ? 18 : 16,
                  lineHeight: 1.75,
                  marginBottom: 28,
                  maxWidth: 520,
                }}
              >
                Veja de perto o padrão visual do nosso banho de ouro para
                semijoias. Cada detalhe do processo é pensado para entregar
                brilho uniforme, acabamento premium e mais percepção de valor
                para a peça final.
              </Paragraph>

              <Space
                direction="vertical"
                size={14}
                style={{
                  width: "100%",
                  marginBottom: 30,
                }}
              >
                {highlights.map((item) => (
                  <div
                    key={item}
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: 12,
                      color: "#f5f5f5",
                      fontSize: isDesktop ? 16 : 15,
                      lineHeight: 1.5,
                    }}
                  >
                    <CheckCircleFilled
                      style={{
                        color: "#d2ab71",
                        fontSize: 18,
                        marginTop: 2,
                        flexShrink: 0,
                      }}
                    />
                    <span>{item}</span>
                  </div>
                ))}
              </Space>

              {/* <Button
                type="primary"
                size="large"
                icon={<ArrowRightOutlined />}
                style={{
                  height: 48,
                  width: isDesktop ? "fit-content" : "100%",
                  padding: isDesktop ? "0 24px" : "0 18px",
                  borderRadius: 999,
                  background: "#d2ab71",
                  borderColor: "#d2ab71",
                  fontWeight: 600,
                  boxShadow: "0 10px 24px rgba(210,171,113,0.22)",
                }}
              >
                Solicitar orçamento
              </Button> */}
            </div>
          </Col>

          <Col
            xs={24}
            lg={14}
            style={{
              display: "flex",
              height: isDesktop ? "100%" : "auto",
            }}
          >
            <div
              style={{
                width: "100%",
                display: "grid",
                gridTemplateColumns: isDesktop ? "1.35fr 1fr" : "1fr",
                gap: isDesktop ? 20 : 16,
                height: isDesktop ? "100%" : "auto",
              }}
            >
              <div
                style={{
                  background: "#1b1b1b",
                  borderRadius: isDesktop ? 28 : 20,
                  overflow: "hidden",
                  border: "1px solid rgba(255,255,255,0.08)",
                  position: "relative",
                  boxShadow: "0 18px 40px rgba(0,0,0,0.28)",
                  height: isDesktop ? "100%" : 340,
                  minHeight: 0,
                }}
              >
                <img
                  src="/images/prova-ouro-main.jpg"
                  alt="Resultado do banho de ouro em semijoias"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: "block",
                  }}
                />

                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    background:
                      "linear-gradient(to top, rgba(0,0,0,0.55), rgba(0,0,0,0.08) 45%, rgba(0,0,0,0))",
                  }}
                />

                <div
                  style={{
                    position: "absolute",
                    left: isDesktop ? 24 : 16,
                    right: isDesktop ? 24 : 16,
                    bottom: isDesktop ? 22 : 16,
                    color: "#fff",
                  }}
                >
                  <div
                    style={{
                      fontSize: isDesktop ? 13 : 11,
                      letterSpacing: 0.5,
                      color: "rgba(255,255,255,0.72)",
                      marginBottom: 8,
                    }}
                  >
                    DETALHE DO ACABAMENTO
                  </div>

                  <div
                    style={{
                      fontSize: isDesktop ? 24 : 20,
                      fontWeight: 700,
                      lineHeight: 1.2,
                    }}
                  >
                    Brilho, acabamento e presença visual premium
                  </div>
                </div>
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateRows: isDesktop ? "0.9fr 1.1fr" : "auto",
                  gap: isDesktop ? 20 : 16,
                  height: isDesktop ? "100%" : "auto",
                  minHeight: 0,
                }}
              >
                <div
                  style={{
                    background: "#1b1b1b",
                    borderRadius: isDesktop ? 24 : 20,
                    overflow: "hidden",
                    border: "1px solid rgba(255,255,255,0.08)",
                    position: "relative",
                    boxShadow: "0 14px 32px rgba(0,0,0,0.22)",
                    minHeight: 0,
                    height: isDesktop ? "100%" : 220,
                  }}
                >
                  <img
                    src="/images/prova-ouro-2.jpg"
                    alt="Peça com banho de ouro"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                    }}
                  />

                  <div
                    style={{
                      position: "absolute",
                      inset: 0,
                      background:
                        "linear-gradient(to top, rgba(0,0,0,0.42), rgba(0,0,0,0.02))",
                    }}
                  />

                  <div
                    style={{
                      position: "absolute",
                      left: 16,
                      right: 16,
                      bottom: 16,
                      color: "#fff",
                      fontWeight: 600,
                      fontSize: isDesktop ? 16 : 15,
                      lineHeight: 1.3,
                    }}
                  >
                    Uniformidade no brilho
                  </div>
                </div>

                <div
                  style={{
                    display: "grid",
                    gridTemplateRows: isDesktop ? "0.9fr 1.1fr" : "auto auto",
                    gap: isDesktop ? 20 : 16,
                    height: isDesktop ? "100%" : "auto",
                    minHeight: 0,
                  }}
                >
                  <div
                    style={{
                      background: "#f8f6f2",
                      borderRadius: isDesktop ? 24 : 20,
                      padding: isDesktop ? "24px 22px" : "22px 18px",
                      border: "1px solid rgba(210,171,113,0.18)",
                      boxShadow: "0 10px 24px rgba(0,0,0,0.12)",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      minHeight: 0,
                      height: isDesktop ? "100%" : "auto",
                    }}
                  >
                    <div
                      style={{
                        fontSize: isDesktop ? 13 : 12,
                        fontWeight: 700,
                        letterSpacing: 0.5,
                        color: "#a8844f",
                        marginBottom: 10,
                      }}
                    >
                      PADRÃO GOLD SERVICE
                    </div>

                    <div
                      style={{
                        fontSize: isDesktop ? 20 : 18,
                        lineHeight: 1.35,
                        color: "#1f1f1f",
                        fontWeight: 700,
                        marginBottom: 8,
                      }}
                    >
                      Acabamento pensado para marcas que precisam de percepção premium
                    </div>

                    <div
                      style={{
                        fontSize: isDesktop ? 15 : 14,
                        color: "#666",
                        lineHeight: 1.6,
                      }}
                    >
                      Mais valor visual para a peça e mais confiança para sua operação.
                    </div>
                  </div>

                  <div
                    style={{
                      background: "#1b1b1b",
                      borderRadius: isDesktop ? 24 : 20,
                      overflow: "hidden",
                      border: "1px solid rgba(255,255,255,0.08)",
                      position: "relative",
                      boxShadow: "0 14px 32px rgba(0,0,0,0.22)",
                      minHeight: 0,
                      height: isDesktop ? "100%" : 220,
                    }}
                  >
                    <img
                      src="/images/prova-ouro-3.jpg"
                      alt="Close de acabamento em peça dourada"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        display: "block",
                      }}
                    />

                    <div
                      style={{
                        position: "absolute",
                        inset: 0,
                        background:
                          "linear-gradient(to top, rgba(0,0,0,0.42), rgba(0,0,0,0.02))",
                      }}
                    />

                    <div
                      style={{
                        position: "absolute",
                        left: 16,
                        right: 16,
                        bottom: 16,
                        color: "#fff",
                        fontWeight: 600,
                        fontSize: isDesktop ? 16 : 15,
                        lineHeight: 1.3,
                      }}
                    >
                      Close no acabamento final
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
}

export default ProofResultsSection;